import React from 'react';
import cx from 'classnames';

import ChevronS2Right from '../Icons/ChevronS2Right';
import ChevronS2Left from '../Icons/ChevronS2Left';
import Touchable, { TouchableProps } from '../Touchable';

import styles from './PrimaryLink.module.scss';

export interface Props extends TouchableProps {
  icon?: React.ReactElement;
  /** Apply CSS class to the icon container. */
  iconClassName?: Parameters<typeof cx>[0];
  /** If `true`, will hide the trailing icon. */
  hasIcon?: boolean;
  left?: boolean;
  // deprecated props, do not use
  back?: boolean;
}

export const PrimaryLink: React.FC<Props> = ({
  back,
  children,
  className,
  disabled,
  icon,
  left,
  size,
  iconClassName,
  hasIcon = true,
  ...restProps
}) => (
  <Touchable
    {...restProps}
    size={size != null ? size : 16}
    className={cx(
      styles.baseLink,
      styles.primaryLink,
      disabled && styles.disabled,
      className,
    )}
  >
    {(left || back || icon != null) &&
      (icon != null ? (
        React.cloneElement(icon, { className: cx(styles.icon, iconClassName) })
      ) : (
        <ChevronS2Left className={styles.leftChevron} />
      ))}
    {children}
    {!back && !left && icon == null && hasIcon === true && (
      <ChevronS2Right className={styles.rightChevron} />
    )}
  </Touchable>
);

PrimaryLink.displayName = 'PrimaryLink';
export default PrimaryLink;
export { styles };
